export enum Scope {
  PROFILE = 'profile',
  EMAIL = 'email',
  DRIVE = 'https://www.googleapis.com/auth/drive.file',
  PUBSUB = 'https://www.googleapis.com/auth/pubsub'
}
